import React from "react";
import AddRegionForm from "../forms/AddRegionForm";
import AddLocationForm from "../forms/AddLocationForm";
import AddPodiumForm from "../forms/AddPodiumForm";
import PodiumCapacityConfig from "./PodiumCapacityConfig";
import "./AdminSetup.css";

// NEEDS A BIT MORE ROOM TO SHOW COMPLETE AddPodiumForm.

const AdminSetup = () => (
    <section className="page-scroll">
        <div className="page-scroll-inner admin-setup-page">
            <div className="admin-section">
                <h3>New Region</h3>
                <AddRegionForm />
            </div>
            <div className="admin-section">
                <h3>New Location</h3>
                <AddLocationForm />
            </div>
            <div className="admin-section">
                <h3>New Podium</h3>
                <AddPodiumForm />
            </div>
            <div className="admin-section">
                <h3>Podium Capacity Setup</h3>
                <PodiumCapacityConfig />
            </div>
        </div>
    </section>
);

export default AdminSetup;
